/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable one-var */
import { json } from 'node:stream/consumers'

import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded'
import Brightness1RoundedIcon from '@mui/icons-material/Brightness1Rounded'
import CropSquareIcon from '@mui/icons-material/CropSquare'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded'
import EditIcon from '@mui/icons-material/Edit'
import FmdGoodIcon from '@mui/icons-material/FmdGood'
import HexagonRoundedIcon from '@mui/icons-material/HexagonRounded'
import ManageHistoryIcon from '@mui/icons-material/ManageHistory'
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye'
import RectangleRoundedIcon from '@mui/icons-material/RectangleRounded'
import SaveAsRoundedIcon from '@mui/icons-material/SaveAsRounded'
import {
  Badge,
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  Paper,
  SpeedDialAction,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material'
import SpeedDial, { SpeedDialProps } from '@mui/material/SpeedDial'
import SpeedDialIcon from '@mui/material/SpeedDialIcon'
import { styled, useTheme } from '@mui/material/styles'
import { useLeafletContext } from '@react-leaflet/core'
import { Dispatch } from '@reduxjs/toolkit'
import { CircularProgressBar } from '@tomik23/react-circular-progress-bar'
import axios from 'axios'
import { faIR } from 'date-fns/locale'
import L, { circle } from 'leaflet'
import _ from 'lodash'
import React, { useEffect, useRef, useState } from 'react'
import gregorian from 'react-date-object/calendars/gregorian'
import persian from 'react-date-object/calendars/persian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import persian_fa from 'react-date-object/locales/persian_fa'
import { useTranslation } from 'react-i18next'
import {
  MapContainer,
  TileLayer,
  Popup,
  Marker,
  Circle,
  FeatureGroup,
  useMapEvents,
} from 'react-leaflet'
import { EditControl } from 'react-leaflet-draw'
import { DateObject } from 'react-multi-date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Speedometer, {
  Background,
  Arc,
  Needle,
  Progress,
  Marks,
  Indicator,
  DangerPath,
} from 'react-speedometer'
import { Layer } from 'recharts'
import swal from 'sweetalert'
import * as Yup from 'yup'

import imageIcon1 from '../../assests/icons/car.gif'
import { IsItem } from '../../interfaces/IsItem'
import { IsServiceItem } from '../../interfaces/IsServiceItem'
import { FormField, SubmitButton, Form } from '../../shared/forms'
import FormSelect from '../../shared/forms/FormSelect'
import InputText from '../../shared/Input'
import SelectText from '../../shared/Select'
import {
  GeofenceCreate,
  GeofenceDelete,
  GeofencesList,
  getGeofenceList,
  getLatiTude,
  getLongiTude,
  GeofenceActivities,
  getGeofenceActivities,
  resetListGeofence,
  getGeofenceCreate,
  resetactivitiesGeofence,
  resetLatLng,
  deleteLastGeofence,
  getGeofenceActivitiesList,
  GeofenceActivitiesList,
  resetactivitiesGeofenceList,
  getLastPosition,
  getLastPositionDevice,
  resetLastPositionDevice,
  LastPositionDevice,
} from '../../store/devices'
const flagCircle = L.icon({
  iconUrl: imageIcon1,
  iconSize: [25, 25],
})
const alarmType: IsItem[] = [
  { id: '1', label: 'ورود به محدوده', value: '1' },
  { id: '2', label: 'خروج از محدوده ', value: '2' },
  { id: '3', label: 'ورود و خروج از محدوده', value: '3' },
]
interface FormValues {
  hesar: string
  alarm: string
}

const initialValues: FormValues = { hesar: '', alarm: alarmType[0].value }

const validationSchema = Yup.object().shape({
  hesar: Yup.string()
    .max(15, ' حداکثر 15 کارکتر مجاز می باشد')
    .required('ورود عنوان اجباری است')
    .label('hesar'),
  alarm: Yup.string().required('انتخاب نوع هشدار اجباری است').label('alarm'),
})
const LocationScreen = () => {
  const matches = useMediaQuery('(min-width:600px)')
  const matches1 = useMediaQuery('(max-width:300px)')
  const { id } = useParams()
  const [selectValue, setSelectValue] = useState(1)
  const { t } = useTranslation()
  const latitude = useSelector(getLatiTude)
  const longitude = useSelector(getLongiTude)

  const geofenceCreate = useSelector(getGeofenceCreate)
  const listGeofence = useSelector(getGeofenceList)
  const rows = useSelector(getGeofenceActivities)
  const activitiesGeoList = useSelector(getGeofenceActivitiesList)
  const position = [latitude, longitude]
  const fillBlueOptions = { fillColor: 'blue' }
  const [list, setList] = useState('')
  const dispatch = useDispatch<Dispatch<any>>()
  const navigate = useNavigate()
  const editRef = React.useRef<any>()
  const refFeatureGroup = React.useRef<any>()
  const [flag, setFlag] = useState(false)
  const [Shape, setDrawing] = useState(false)

  const onMountedRect = (e: any) => {
    editRef.current = e
  }
  const [address, setAddress] = useState()
  // تابع تبدیل نقطه جغرافیایی با آدرس با پلتفرم نشان
  async function getUsers() {
    try {
      if (latitude === '' || longitude === '') return
      await axios
        .get(
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          `https://api.neshan.org/v5/reverse?lat=${latitude}&lng=${longitude}`,
          {
            headers: {
              'Api-Key': 'service.da5f3022ea194c4a97ca9c33cd46efd8',
            },
          },
        )
        .then((response) => {
          setAddress(response.data.formatted_address)
          const s = swal(response.data.formatted_address, 'موقعیت فعلی')
        })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.message
      } else {
        return 'An unexpected error occurred'
      }
    }
  }
  const [addressLive, setAddressLive] = useState()
  // تابع تبدیل نقطه جغرافیایی با آدرس با پلتفرم نشان

  async function getAddress() {
    try {
      if (lastPositionDevice?.gps?.latitude === '' || lastPositionDevice?.gps?.longitude === '')
        return
      await axios
        .get(
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          `https://api.neshan.org/v5/reverse?lat=${lastPositionDevice?.gps?.latitude}&lng=${lastPositionDevice?.gps?.longitude}`,
          {
            headers: {
              'Api-Key': 'service.da5f3022ea194c4a97ca9c33cd46efd8',
            },
          },
        )
        .then((response) => {
          setAddressLive(response.data.formatted_address)
          // const s = swal(response.data.formatted_address, 'موقعیت فعلی')
        })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.message
      } else {
        return 'An unexpected error occurred'
      }
    }
  }
  // اطلاعات مربوط به ترسیم حصار

  L.drawLocal.draw.handlers.rectangle.tooltip.start = 'مستطیل بکشید'
  L.drawLocal.draw.handlers.circle.tooltip.start = 'دایره بکشید'
  L.drawLocal.draw.handlers.simpleshape.tooltip.end = 'جهت ایجاد شکل نشانگر را رها کنید'

  const [drawCircle, setDrawCircle] = useState(false)
  const [drawRectangle, setDrawRectangle] = useState(false)
  const [typing, setTyping] = useState<any>()
  const pos = (e: any) => setTyping(e)

  const pos1 = (e: any) => {}
  const pos2 = (e: any) => {}

  const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
    position: 'absolute',
    '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
      bottom: '1vh',
      right: theme.spacing(2),
    },
    '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
      top: theme.spacing(0),
      left: theme.spacing(0),
    },
  }))
  // اطلاعات مربوط به ترسیم حصار

  const actions: IsServiceItem[] = [
    {
      id: '2',
      title: t('screens.LocationScreen.circle'),
      icon: <Brightness1RoundedIcon fontSize='medium' sx={{ color: 'white' }} />,
      onClick: () => {
        if (listGeofence.length < 9) {
          editRef.current._toolbars.draw._modes.circle.handler.enable()
        } else {
          const a = swal(
            'تعداد شکل های مجاز به حد نصاب رسیده است',
            'جهت ادامه کلیک کنید',
            'success',
          )
        }
      },
    },

    {
      id: '3',
      title: t('screens.LocationScreen.rectangle'),
      icon: <RectangleRoundedIcon fontSize='medium' sx={{ color: 'white' }} />,
      onClick: () => {
        if (listGeofence.length < 9) {
          editRef.current._toolbars.draw._modes.rectangle.handler.enable()
        } else {
          const a = swal(
            'تعداد شکل های مجاز به حد نصاب رسیده است',
            'جهت ادامه کلیک کنید',
            'success',
          )
        }
      },
    },
  ]
  const [hidden, setHidden] = React.useState(false)
  const [open1, setOpen1] = React.useState(false)
  const [open2, setOpen2] = React.useState(false)
  const [open3, setOpen3] = React.useState(false)
  const [openGeoFenceList, setOpenGeoFenceList] = React.useState(false)

  const [isTitle, setIsTitle] = useState('')

  const [editMode, setEditMode] = useState(false)
  const [editMode1, setEditMode1] = useState(false)

  const handleClickOpen1 = () => {
    setOpen1(true)
  }

  const [final, setFinal] = React.useState<any>([])

  const handleSaveCircle = () => {
    setOpen1(false)
    setDrawCircle(false)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      layer.bindTooltip(isTitle).openTooltip()
      // })
      setFinal({
        title: isTitle,
        layer: JSON.stringify(layer),
        mode: selectValue,
        shape: 1,
        latitude0: layer._latlng.lat,
        longitude0: layer._latlng.lng,
        radius: layer._radius,
      })
    }

    setIsTitle('')
  }

  const handleSaveRectangle = (e: any) => {
    setOpen2(false)
    setDrawRectangle(false)

    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      // layer.on('click', function (e: any) {
      //   L.tooltip()
      //     .setLatLng([e.latlng.lat, e.latlng.lng])
      //     .setContent(isTitle)
      //     .addTo(refFeatureGroup.current)

      layer.bindTooltip(isTitle).openTooltip()
      // })
      setFinal({
        title: isTitle,
        layer,
        mode: selectValue,
        shape: 3,
        latitude0: layer._latlngs[0][0].lat,
        longitude0: layer._latlngs[0][0].lng,
        latitude1: layer._latlngs[0][1].lat,
        longitude1: layer._latlngs[0][1].lng,
        latitude2: layer._latlngs[0][2].lat,
        longitude2: layer._latlngs[0][2].lng,
        latitude3: layer._latlngs[0][3].lat,
        longitude3: layer._latlngs[0][3].lng,
      })
    }
    setIsTitle('')
  }
  const lastPositionDevice = useSelector(getLastPositionDevice)

  useEffect(() => {
    dispatch(GeofencesList({ deviceId: id }))
    if (id !== undefined) dispatch(getLastPosition(id))
    void getUsers()
  }, [])

  const handleCancel = (e: any) => {
    setOpen1(false)
    setDrawCircle(false)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }

    // }
  }
  const handleCancelRectangle = (e: any) => {
    setOpen2(false)
    setDrawRectangle(false)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      refFeatureGroup.current.removeLayer(layer)
      drafts.pop()
    }

    // }
  }
  const handleCancelOpen = (e: any) => {
    setOpen3(false)
    dispatch(resetactivitiesGeofence)

    // }
  }
  const [drafts, setDrafts] = React.useState<any>([])
  const [idGeo, setIdGeo] = useState<any>()
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands

  const handleColor = () => {
    // drafts.forEach((p: any) => refFeatureGroup.current.addLayer(p.layer))
    refFeatureGroup.current.clearLayers()

    if (listGeofence !== undefined) {
      // eslint-disable-next-line array-callback-return
      listGeofence.map((p: any) => {
        if (p.shape === 0) {
          L.circle([p.latitude0, p.longitude0], { radius: p.radius, color: '#ff7800', weight: 5 })
            .bindTooltip(p.title)
            .openTooltip()
            .addTo(refFeatureGroup.current)
            .addEventListener('click', () => {
              dispatch(GeofenceActivities({ deviceId: id, geoId: p.geoId }))
              setTitleGeo(p.title)
              setIdGeo(p.id)
              setOpen3(true)
            })
        } else if (p.shape === 3) {
          L.rectangle(
            [
              [p.latitude0, p.longitude0],
              [p.latitude1, p.longitude1],
              [p.latitude2, p.longitude2],
              [p.latitude3, p.longitude3],
            ],
            { color: '#ff7800', weight: 5 },
          )
            .bindTooltip(p.title)
            .openTooltip()
            .addTo(refFeatureGroup.current)
            .addEventListener('click', () => {
              dispatch(GeofenceActivities({ deviceId: id, geoId: p.geoId }))
              setTitleGeo(p.title)
              setIdGeo(p.id)
              setOpen3(true)
            })
        }
      })
    }
  }
  const [flagLastPosition, setFlagLastPosition] = useState(false)
  const handleLiveLocation = () => {
    setFlagLastPosition(true)
  }
  const handleLiveLocation1 = () => {
    setFlagLastPosition(false)
    dispatch(resetLastPositionDevice)
  }

  const handleColor1 = () => {
    // map.flyTo([latitude, longitude])
    dispatch(GeofenceActivitiesList({ deviceId: id }))
    setOpenGeoFenceList(true)
  }
  useEffect(() => {
    if (flagLastPosition) {
      const refreshIntervalId = setInterval(() => {
        if (id !== undefined) dispatch(LastPositionDevice(id))
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [flagLastPosition])

  useEffect(() => {
    if (drafts.length !== 0 && drafts[drafts.length - 1].layerType === 'circle') {
      setDrawCircle(true) // Do marker specific actions
    } else if (drafts.length !== 0 && drafts[drafts.length - 1].layerType === 'rectangle') {
      setDrawRectangle(true)
    }
  }, [drafts])

  const onShapeDrawn = (e: L.DrawEvents.Created) => {
    setDrafts((drafts: any) => [...drafts, e])

    // if (drafts[drafts.length - 1].layerType === 'circle') {
    //   setDrawCircle(true) // Do marker specific actions
    // } else {
    //   setDrawRectangle(true)
    // }
    // Do whatever else you need to. (save to db; add to map etc)
  }
  useEffect(() => {
    if (drawCircle) {
      setOpen1(true)
    }
  }, [drawCircle])
  useEffect(() => {
    if (drawRectangle) {
      setOpen2(true)
    }
  }, [drawRectangle])
  interface Column {
    id: 'id' | 'day' | 'dateTime' | 'action'

    label: string
    minWidth?: number
    align?: 'center'
    format?: (value: number) => string
  }
  const columns: readonly Column[] = [
    { id: 'id', label: 'شماره', minWidth: matches ? 50 : 10, align: 'center' },
    { id: 'day', label: 'روز', minWidth: matches ? 50 : 10, align: 'center' },
    { id: 'dateTime', label: 'تاریخ ', minWidth: matches ? 50 : 10, align: 'center' },
    { id: 'action', label: 'نوع ', minWidth: matches ? 50 : 10, align: 'center' },
  ]
  // تابع تبدیل تاریخ شمسی به میلادی
  const shamsi = (time: string) => {
    if (time === undefined) return
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('YYYY/MM/DD HH:mm:ss')
  }
  const shamsiDay = (time: any) => {
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.weekDay.name
  }
  L.EditToolbar.Delete.include({
    removeAllLayers: false,
  })

  const [map, setMap] = useState<any>(null)
  const [message, setMessage] = useState('')
  const [titleGeo, setTitleGeo] = useState()
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsTitle(e.target.value)
  }
  const handleChange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsTitle(e.target.value)
  }

  const handleSubmit1 = (values: any) => {
    setOpen1(false)
    setDrawCircle(false)
    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      // layer.on('click', function (e: any) {
      //   L.tooltip()
      //     .setLatLng([e.latlng.lat, e.latlng.lng])
      //     .setContent(isTitle)
      //     .addTo(refFeatureGroup.current)

      layer.bindTooltip(values.hesar).openTooltip()
      // })
      dispatch(
        GeofenceCreate({
          deviceId: id,
          title: values.hesar,
          mode: values.alarm,
          shape: 0,
          latitude0: layer._latlng.lat,
          longitude0: layer._latlng.lng,
          radius: layer._mRadius,
        }),
      )
      // dispatch(GeofencesList({ deviceId: id }))
      layer.on('click', function (e: any) {
        const a = swal('جهت مدیریت روی حصار جغرافیایی بزنید')
      })
    }

    setIsTitle('')
  }

  const handleSubmit = (values: any) => {
    setOpen2(false)
    setDrawRectangle(false)

    if (drafts.length !== 0) {
      const layer = drafts[drafts.length - 1].layer

      layer.bindTooltip(values.hesar).openTooltip()

      dispatch(
        GeofenceCreate({
          deviceId: id,
          title: values.hesar,
          mode: values.alarm,
          shape: 3,
          latitude0: layer._latlngs[0][0].lat,
          longitude0: layer._latlngs[0][0].lng,
          latitude1: layer._latlngs[0][1].lat,
          longitude1: layer._latlngs[0][1].lng,
          latitude2: layer._latlngs[0][2].lat,
          longitude2: layer._latlngs[0][2].lng,
          latitude3: layer._latlngs[0][3].lat,
          longitude3: layer._latlngs[0][3].lng,
        }),
      )
      // dispatch(GeofencesList({ deviceId: id }))
      layer.on('click', function (e: any) {
        const a = swal('جهت مدیریت روی حصار جغرافیایی بزنید')
      })
    }

    setIsTitle('')
  }
  useEffect(() => {
    return () => {
      dispatch(resetListGeofence)
      dispatch(resetLatLng)
      dispatch(resetactivitiesGeofenceList)
      dispatch(resetLastPositionDevice)
    }
  }, [])
  useEffect(() => {
    if (map !== null && latitude !== undefined && longitude !== undefined) {
      map.flyTo([latitude, longitude])
    }
  }, [latitude, longitude])
  // const handleDeleteGeo = () => {
  //   dispatch(GeofenceDelete())
  // }

  const handleCloseListGeoFence = () => {
    setOpenGeoFenceList(false)
  }

  const handleDelete = () => {
    refFeatureGroup.current.clearLayers()
    dispatch(deleteLastGeofence)
  }
  const [checked, setChecked] = useState(false)
  const switchHandler = (event: any) => {
    setChecked(event.target.checked)
  }

  useEffect(() => {
    if (checked) {
      setFlagLastPosition(true)
    } else {
      dispatch(resetLastPositionDevice)
      setFlagLastPosition(false)
      setAddressLive(undefined)
    }
  }, [checked])

  useEffect(() => {
    if (lastPositionDevice !== undefined || checked) {
      const refreshIntervalId = setInterval(() => {
        void getAddress()
      }, 1000)
      return () => {
        clearInterval(refreshIntervalId)
      }
    }
  }, [lastPositionDevice])

  const theme = useTheme()
  const onlySmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const onlyMediumScreen = useMediaQuery(theme.breakpoints.down('md'))
  const onlyLargeScreen = useMediaQuery(theme.breakpoints.down('lg'))
  const onxlyLargeScreen = useMediaQuery(theme.breakpoints.down('xl'))

  const responsiveValue = matches1
    ? 110
    : onlySmallScreen
    ? 150
    : onlyMediumScreen
    ? 300
    : onlyLargeScreen
    ? 350
    : onxlyLargeScreen
    ? 250
    : 250
  const responsiveFontSize = matches1
    ? 10
    : onlySmallScreen
    ? 10
    : onlyMediumScreen
    ? 20
    : onlyLargeScreen
    ? 20
    : onxlyLargeScreen
    ? 15
    : 15
  const responsiveLineSize = matches1
    ? 5
    : onlySmallScreen
    ? 12
    : onlyMediumScreen
    ? 20
    : onlyLargeScreen
    ? 20
    : onxlyLargeScreen
    ? 20
    : 20
  const responsiveFontSizeText = matches1
    ? 10
    : onlySmallScreen
    ? 8
    : onlyMediumScreen
    ? 15
    : onlyLargeScreen
    ? 20
    : onxlyLargeScreen
    ? 15
    : 15
  const responsiveStroke = matches1
    ? 1
    : onlySmallScreen
    ? 2
    : onlyMediumScreen
    ? 5
    : onlyLargeScreen
    ? 8
    : onxlyLargeScreen
    ? 8
    : 5
  const responsiveCircle = matches1
    ? 5
    : onlySmallScreen
    ? 10
    : onlyMediumScreen
    ? 20
    : onlyLargeScreen
    ? 20
    : onxlyLargeScreen
    ? 20
    : 20
  const responsiveText = matches1
    ? 5
    : onlySmallScreen
    ? 70
    : onlyMediumScreen
    ? 150
    : onlyLargeScreen
    ? 180
    : onxlyLargeScreen
    ? 125
    : 125
  const responsiveText1 = matches1
    ? 5
    : onlySmallScreen
    ? 200 / 2
    : onlyMediumScreen
    ? 380 / 2
    : onlyLargeScreen
    ? 440 / 2
    : onxlyLargeScreen
    ? 350 / 2
    : 350 / 2
  const responsiveText2 = matches1
    ? 5
    : onlySmallScreen
    ? 225 / 2
    : onlyMediumScreen
    ? 430 / 2
    : onlyLargeScreen
    ? 500 / 2
    : onxlyLargeScreen
    ? 405 / 2
    : 405 / 2
  const responsiveText3 = matches1
    ? 5
    : onlySmallScreen
    ? 255 / 2
    : onlyMediumScreen
    ? 470 / 2
    : onlyLargeScreen
    ? 560 / 2
    : onxlyLargeScreen
    ? 450 / 2
    : 450 / 2

  const responsiveBox = {
    '&.MuiBox-root': {
      // width: { xs: 100, sm: 100, md: 200, lg: 226 },
      paddingTop: { xs: 2, sm: 2, md: 2, lg: 0 },
    },
  }
  //
  return (
    <Box
      position='relative'
      sx={{
        width: '100vw',
        height: '90vh',
        '& .leaflet-right': { display: 'none' },
        '& .leaflet-popup-content': { fontFamily: 'Vazir' },
        '& .leaflet-container': { fontFamily: 'Vazir', fontSize: 15 },
        '& .leaflet-interactive': { outline: 'none' },
      }}
    >
      <MapContainer
        center={
          latitude !== undefined && longitude !== undefined
            ? [latitude, longitude]
            : [35.7219, 51.3347]
        }
        ref={setMap}
        scrollWheelZoom={false}
        style={{ minHeight: '100%', minWidth: '100%' }}
        zoom={16}
      >
        <Box sx={{ '& path.leaflet-interactive:focus': { outline: 'none' } }}>
          <FeatureGroup ref={refFeatureGroup}>
            <EditControl
              draw={{
                rectangle: { shapeOptions: { color: 'red' } },
                circle: { shapeOptions: { color: 'red' } },
                circlemarker: false,
                polyline: false,
                marker: false,
                polygon: { showLength: true, shapeOptions: { color: 'red' } },
              }}
              // edit={{ edit: false}}
              onCreated={onShapeDrawn}
              onDeleted={pos2}
              onMounted={onMountedRect}
              position='topright'
            />
          </FeatureGroup>
        </Box>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        />
        {latitude !== undefined && (
          <Circle center={[latitude, longitude]} pathOptions={fillBlueOptions} radius={200} />
        )}
        {lastPositionDevice !== undefined && checked && (
          <Marker
            icon={flagCircle}
            position={[lastPositionDevice?.gps?.latitude, lastPositionDevice?.gps?.longitude]}
          />
        )}
        {latitude !== undefined && (
          <Marker position={[latitude, longitude]}>
            <Popup>موقعیت فعلی: {address}</Popup>
          </Marker>
        )}
        {/* <LoadingMap /> */}
      </MapContainer>
      {!checked ? (
        <StyledSpeedDial
          ariaLabel='SpeedDial playground example'
          dir='ltr'
          direction='left'
          hidden={hidden}
          icon={<SpeedDialIcon openIcon={<EditIcon />} />}
        >
          {actions.map((action) => (
            <SpeedDialAction
              icon={action.icon}
              key={action.id}
              onClick={action.onClick}
              sx={{ background: 'red' }}
              tooltipTitle={action.title}
            />
          ))}
        </StyledSpeedDial>
      ) : (
        ''
      )}

      <div>
        <Dialog
          aria-describedby='alert-dialog-description'
          aria-labelledby='alert-dialog-title'
          onClose={handleCancel}
          open={open1}
        >
          <DialogTitle id='alert-dialog-title'>{t('screens.LocationScreen.setting')}</DialogTitle>
          <DialogContent>
            <Box display='flex' flexDirection='column' sx={{ direction: 'rtl' }}>
              <Form
                initialValues={initialValues}
                onSubmit={handleSubmit1}
                validationSchema={validationSchema}
              >
                <InputLabel id='demo-simple-select-label'>
                  {t('screens.LocationScreen.title_box')}
                </InputLabel>
                <FormField name='hesar' placeholder={t('screens.LocationScreen.name_geofencing')} />
                <InputLabel id='demo-simple-select-label'>
                  {t('screens.LocationScreen.warning_in_case')}
                </InputLabel>
                <FormSelect
                  defaultValue={alarmType[0].value}
                  items={alarmType}
                  name='alarm'
                  placeholder={t('screens.LocationScreen.warning_in_case')}
                />
                <SubmitButton fullWidth title={t('screens.LocationScreen.save')} />
              </Form>
              <Button onClick={handleCancel} sx={{ mt: 1 }}>
                {t('screens.LocationScreen.cancel')}
              </Button>
              {/* <InputLabel id='demo-simple-select-label'>عنوان:</InputLabel>
              <InputText onChange={handleChange} placeholder='نام حصارجغرافیایی' />
              <InputLabel id='demo-simple-select-label'>هشدار در صورت:</InputLabel>
              <SelectText
                defaultValue={alarmType[0].value}
                items={alarmType}
                onChange={(e: any) => setSelectValue(parseInt(e.target.value))}
              />
              <Box display='flex' flexDirection='row'>
                <Button onClick={handleSaveCircle}>ذخیره</Button>
                <Button onClick={handleCancel}>لغو</Button>
              </Box> */}
              {/* <input onChange={handleChange} value={isTitle} /> */}
            </Box>
          </DialogContent>
        </Dialog>
      </div>
      <div>
        <Dialog
          aria-describedby='alert-dialog-description'
          aria-labelledby='alert-dialog-title'
          onClose={handleCancelRectangle}
          open={open2}
        >
          <DialogTitle id='alert-dialog-title'>{'تنظیمات'}</DialogTitle>
          <DialogContent>
            <Box display='flex' flexDirection='column' sx={{ direction: 'rtl' }}>
              <Form
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
              >
                <InputLabel id='demo-simple-select-label'>
                  {t('screens.LocationScreen.title_box')}
                </InputLabel>
                <FormField name='hesar' placeholder={t('screens.LocationScreen.name_geofencing')} />
                <InputLabel id='demo-simple-select-label'>
                  {t('screens.LocationScreen.warning_in_case')}
                </InputLabel>
                <FormSelect
                  defaultValue={alarmType[0].value}
                  items={alarmType}
                  name='alarm'
                  placeholder={t('screens.LocationScreen.warning_in_case')}
                />
                <SubmitButton fullWidth title={t('screens.LocationScreen.save')} />
              </Form>
              <Button onClick={handleCancelRectangle} sx={{ mt: 1 }}>
                {t('screens.LocationScreen.cancel')}
              </Button>
              {/* <InputLabel id='demo-simple-select-label'>عنوان:</InputLabel>
              <InputText onChange={handleChange} placeholder='نام حصارجغرافیایی' />
              <InputLabel id='demo-simple-select-label'>هشدار در صورت:</InputLabel>
              <SelectText
                defaultValue={alarmType[0].value}
                items={alarmType}
                onChange={(e: any) => setSelectValue(parseInt(e.target.value))}
              />
              <Box display='flex' flexDirection='row'>
                <Button onClick={handleSaveRectangle}>ذخیره</Button>
               <Button onClick={handleCancelRectangle}>لغو</Button>
              </Box> */}
              {/* <input onChange={handleChange} value={isTitle} /> */}
            </Box>
          </DialogContent>
        </Dialog>
      </div>

      <div>
        <Dialog
          aria-describedby='alert-dialog-description'
          aria-labelledby='alert-dialog-title'
          // onClose={handleCancelRectangle}
          open={open3}
          sx={{ maxHeight: 600 }}
        >
          <DialogTitle id='alert-dialog-title'>{titleGeo}</DialogTitle>
          <DialogContent>
            <Box
              display='flex'
              flexDirection='column'
              sx={{ direction: 'rtl', '& .MuiTableCell-root': { padding: '1px 13px' } }}
            >
              <Paper sx={{ width: '102%', overflow: 'hidden', direction: 'rtl' }}>
                {rows?.data?.length !== 0 ? (
                  <TableContainer sx={{ maxHeight: 400 }}>
                    <Table aria-label='sticky table' size='small' stickyHeader>
                      <TableHead>
                        <TableRow
                          sx={{
                            '&:last-child td, &:last-child th': { backgroundColor: 'lightgray' },
                          }}
                        >
                          {columns.map((column) => (
                            <TableCell
                              align={column.align}
                              key={column.id}
                              style={{ minWidth: column.minWidth, padding: '0' }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows?.data?.map((row: any, index: number) => {
                          return (
                            <TableRow
                              key={row.id}
                              sx={{ '&:nth-of-type(odd)': { backgroundColor: '#fff' } }}
                              tabIndex={-1}
                            >
                              <TableCell align='center'>{index + 1}</TableCell>
                              <TableCell align='center'>{shamsiDay(row.dateTime)}</TableCell>
                              <TableCell align='center'>{shamsi(row.dateTime)}</TableCell>
                              <TableCell align='center'>{row.action}</TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Typography sx={{ p: '14px' }}>
                    {t('screens.HistoryErrorsScreen.no_info')}
                  </Typography>
                )}
              </Paper>
              <Button onClick={handleCancelOpen} sx={{ mt: 1 }}>
                لغو
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </div>

      <div>
        <Dialog
          aria-describedby='alert-dialog-description'
          aria-labelledby='alert-dialog-title'
          onClose={handleCloseListGeoFence}
          open={openGeoFenceList}
          sx={{ maxHeight: 600 }}
        >
          <DialogTitle id='alert-dialog-title'>
            {t('screens.LocationScreen.geofencing_list')}
          </DialogTitle>
          <DialogContent sx={{ width: '300px' }}>
            {listGeofence.length !== 0 ? (
              <Box display='flex' flexDirection='column' sx={{ direction: 'rtl' }}>
                <Card
                  sx={{
                    color: 'white',
                    backgroundColor: '#DC3535',
                    borderRadius: 1,
                    p: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: 2,
                  }}
                >
                  <Box display='flex'>
                    <Typography sx={{ ml: 1, fontSize: 14 }}>
                      {t('screens.LocationScreen.id')}
                    </Typography>

                    <Typography sx={{ ml: 1.5, fontSize: 14 }}>
                      {t('screens.LocationScreen.title')}
                    </Typography>

                    <Typography sx={{ ml: 1.5, fontSize: 14 }}>
                      {t('screens.LocationScreen.shape')}
                    </Typography>

                    <Typography sx={{ ml: 1, fontSize: 14 }}>
                      {t('screens.LocationScreen.show')}
                    </Typography>

                    <Typography sx={{ ml: 1.5, fontSize: 14 }}>
                      {t('screens.LocationScreen.delete')}
                    </Typography>

                    <Typography sx={{ ml: 1, fontSize: 14 }}>
                      {t('screens.LocationScreen.activity')}
                    </Typography>
                  </Box>
                </Card>
                <Divider sx={{ mb: 1 }} variant='middle' />

                {listGeofence.map((p: any, index: number) => (
                  <Card
                    key={p.id}
                    sx={{
                      color: 'grey.700',
                      backgroundColor: '#EDE4E0',
                      borderRadius: 1,
                      p: 1,
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: 2,
                    }}
                  >
                    <Box display='flex' justifyContent='space-between' sx={{ width: '100px' }}>
                      <Box display='flex' sx={{ alignSelf: 'center' }}>
                        <Typography sx={{ ml: 1 }}>{index + 1}</Typography>
                      </Box>
                      <Box sx={{ alignSelf: 'center' }}>
                        <Typography sx={{ ml: 1, fontSize: 13, overflowWrap: 'anywhere' }}>
                          {p.title}
                        </Typography>
                      </Box>
                      <Box sx={{ alignSelf: 'center' }}>
                        <Typography sx={{ ml: 1, fontSize: '13px' }}>
                          {p.shape === 0 ? <PanoramaFishEyeIcon /> : <CropSquareIcon />}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <IconButton
                        onClick={() => {
                          refFeatureGroup.current.clearLayers()
                          if (p.shape === 0) {
                            L.circle([p.latitude0, p.longitude0], {
                              radius: p.radius,
                              color: '#ff7800',
                              weight: 5,
                            })
                              .bindTooltip(p.title)
                              .openTooltip()
                              .addTo(refFeatureGroup.current)
                              .addEventListener('click', () => {
                                dispatch(GeofenceActivities({ deviceId: id, geoId: p.geoId }))
                                setTitleGeo(p.title)
                                setIdGeo(p.id)
                                setOpen3(true)
                              })
                          } else if (p.shape === 3) {
                            L.rectangle(
                              [
                                [p.latitude0, p.longitude0],
                                [p.latitude1, p.longitude1],
                                [p.latitude2, p.longitude2],
                                [p.latitude3, p.longitude3],
                              ],
                              { color: '#ff7800', weight: 5 },
                            )
                              .bindTooltip(p.title)
                              .openTooltip()
                              .addTo(refFeatureGroup.current)
                              .addEventListener('click', () => {
                                dispatch(GeofenceActivities({ deviceId: id, geoId: p.geoId }))
                                setTitleGeo(p.title)
                                setIdGeo(p.id)
                                setOpen3(true)
                              })
                          }
                          map.flyTo([p.latitude0, p.longitude0])
                          setOpenGeoFenceList(false)
                        }}
                      >
                        <FmdGoodIcon sx={{ color: 'red' }} />
                      </IconButton>
                    </Box>
                    <Box>
                      <IconButton
                        onClick={() => {
                          dispatch(GeofenceDelete(p.id))
                          refFeatureGroup.current.clearLayers()
                        }}
                      >
                        <DeleteForeverIcon sx={{ color: 'red' }} />
                      </IconButton>
                    </Box>
                    <Box>
                      <IconButton
                        onClick={() => {
                          dispatch(GeofenceActivities({ deviceId: id, geoId: p.geoId }))
                          setTitleGeo(p.title)

                          setOpen3(true)
                        }}
                      >
                        <Badge
                          badgeContent={
                            activitiesGeoList?.data?.filter((k: any) => k.geoId === p.geoId).length
                          }
                          color='info'
                        >
                          <ManageHistoryIcon sx={{ color: 'green' }} />
                        </Badge>
                        {/* <ManageHistoryIcon sx={{ color: 'green' }} /> */}
                      </IconButton>
                    </Box>
                  </Card>
                ))}
                <Button
                  onClick={() => {
                    refFeatureGroup.current.clearLayers()

                    if (listGeofence !== undefined) {
                      // eslint-disable-next-line array-callback-return
                      listGeofence.map((p: any) => {
                        if (p.shape === 0) {
                          L.circle([p.latitude0, p.longitude0], {
                            radius: p.radius,
                            color: '#ff7800',
                            weight: 5,
                          })
                            .bindTooltip(p.title)
                            .openTooltip()
                            .addTo(refFeatureGroup.current)
                            .addEventListener('click', () => {
                              dispatch(GeofenceActivities({ deviceId: id, geoId: p.geoId }))
                              setTitleGeo(p.title)
                              setIdGeo(p.id)
                              setOpen3(true)
                            })
                        } else if (p.shape === 3) {
                          L.rectangle(
                            [
                              [p.latitude0, p.longitude0],
                              [p.latitude1, p.longitude1],
                              [p.latitude2, p.longitude2],
                              [p.latitude3, p.longitude3],
                            ],
                            { color: '#ff7800', weight: 5 },
                          )
                            .bindTooltip(p.title)
                            .openTooltip()
                            .addTo(refFeatureGroup.current)
                            .addEventListener('click', () => {
                              dispatch(GeofenceActivities({ deviceId: id, geoId: p.geoId }))
                              setTitleGeo(p.title)
                              setIdGeo(p.id)
                              setOpen3(true)
                            })
                        }
                      })
                    }
                  }}
                  sx={{ mt: 1 }}
                  variant='contained'
                >
                  {t('screens.LocationScreen.show_all')}
                </Button>
                <Button onClick={handleCloseListGeoFence} sx={{ mt: 1 }}>
                  {t('screens.LocationScreen.cancel')}
                </Button>
              </Box>
            ) : (
              <Typography component={'span'} sx={{ color: 'red' }}>
                {t('screens.HistoryErrorsScreen.no_info')}
              </Typography>
            )}
          </DialogContent>
        </Dialog>
      </div>

      <IconButton
        onClick={() => navigate(-1)}
        sx={{
          backgroundColor: 'red',
          borderRadius: '50%',
          color: '#fff',
          zIndex: 1501,
          position: 'absolute',
          top: 80,
          left: 0,
          ml: 1,
        }}
      >
        <ArrowBackRoundedIcon />
      </IconButton>

      <Button
        onClick={() => {
          if (map !== null && latitude !== undefined && longitude !== undefined) {
            map.flyTo([latitude, longitude])
          }
        }}
        sx={{
          backgroundColor: 'red',
          borderRadius: '1',
          color: '#fff',
          zIndex: 1501,
          position: 'absolute',
          top: matches ? 52 : 52,
          right: 0,
          mr: 1,
          width: '103px',
        }}
      >
        {t('screens.LocationScreen.current_location')}
      </Button>

      <Button
        onClick={handleColor1}
        sx={{
          backgroundColor: 'red',
          borderRadius: '1',
          color: '#fff',
          zIndex: 1501,
          position: 'absolute',
          top: matches ? 10 : 10,
          right: 0,
          mr: 1,
        }}
      >
        {t('screens.LocationScreen.Geofencing')}
      </Button>
      {/* {!flagLastPosition ? (
        <Button
          onClick={handleLiveLocation}
          sx={{
            backgroundColor: 'red',
            borderRadius: '1',
            color: '#fff',
            zIndex: 1501,
            position: 'absolute',
            top: matches ? 95 : 95,
            right: 0,
            mr: 1,
          }}
        >
          موقعیت زنده
        </Button>
      ) : (
        <Button
          onClick={handleLiveLocation1}
          sx={{
            backgroundColor: 'red',
            borderRadius: '1',
            color: '#fff',
            zIndex: 1501,
            position: 'absolute',
            top: matches ? 95 : 95,
            right: 0,
            mr: 1,
          }}
        >
          لغو موقعیت زنده
        </Button>
      )} */}
      <FormGroup
        sx={{
          borderRadius: 1,

          backgroundColor: '#a2a1a1',
          color: '#fff',
          zIndex: 1501,
          position: 'absolute',
          top: matches ? 95 : 95,
          right: 0,
          mr: 1,
        }}
      >
        <FormControlLabel
          control={<Switch checked={checked} color='primary' onChange={switchHandler} />}
          label={t('screens.LocationScreen.live_location')}
          labelPlacement='bottom'
          sx={{ color: '#fff', '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
          value='bottom'
        />
      </FormGroup>
      {checked && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            ml: 1,
            zIndex: 100000000,
          }}
        >
          <Speedometer
            fontFamily='squada-one'
            max={220}
            value={lastPositionDevice?.gps?.speed}
            width={responsiveValue}
          >
            <Background />
            <Arc arcWidth={0} />
            <Needle circleColor='white' circleRadius={responsiveCircle} color='red' offset={35} />
            <Progress arcWidth={0} color={'red'} />
            <Marks lineSize={responsiveLineSize} numbersRadius={matches ? 17 : 12}>
              {(mark, i) => (
                <g key={i}>
                  {i % 2 === 0 && (
                    <text
                      {...mark.textProps}
                      alignmentBaseline='central'
                      fill={'white'}
                      fontSize={responsiveFontSize}
                      opacity={0.6}
                      textAnchor='middle'
                    >
                      {mark.value}
                    </text>
                  )}

                  <line
                    {...mark.coordinates}
                    stroke={'white'}
                    strokeOpacity={1}
                    strokeWidth={responsiveStroke}
                  />
                </g>
              )}
            </Marks>

            <Indicator>
              {(value, textProps) => (
                <text
                  {...textProps}
                  clipPath=' polygon(30% 0%, 70% 0%, 100% 0, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0 0)'
                  fill='black'
                  filter='url(#solid)'
                  fontFamily='Vazir'
                  fontSize={responsiveFontSizeText}
                  textAnchor='middle'
                  x={responsiveText}
                  y={responsiveText2}
                >
                  <>{value} KM:H</>
                </text>
              )}
            </Indicator>

            <Indicator>
              {(value, textProps) => (
                <text
                  {...textProps}
                  fill={'white'}
                  fontFamily='Vazir'
                  fontSize={responsiveFontSizeText}
                  textAnchor='middle'
                  x={responsiveText}
                  y={responsiveText3}
                >
                  <>سرعت</>
                </text>
              )}
            </Indicator>
          </Speedometer>
          {/* <CircularProgressBar
            colorCircle='gray'
            colorSlice='red'
            cut={30}
            fill='#000'
            fontColor='#fff'
            percent={lastPositionDevice?.gps?.speed}
            rotation={144}
            size={100}
            unit='Km'
          >
            <div
              style={{
                bottom: '15px',
                fontSize: '1rem',
                margin: 'auto',
                position: 'absolute',
                textAlign: 'center',
                color: '#fff',
                width: '100%',
              }}
            >
              سرعت
            </div>
          </CircularProgressBar> */}
        </Box>
      )}

      {/* <Button
        onClick={() => {
          void getAddress()
        }}
        sx={{
          backgroundColor: 'red',
          borderRadius: '1',
          color: '#fff',
          zIndex: 1501,
          position: 'absolute',
          top: matches ? 200 : 200,
          right: 0,
          mr: 1,
        }}
      >
        پاک کردن
      </Button> */}
      {/* {/* <Button
        onClick={handleClick}
        sx={{
          backgroundColor: 'red',

          color: '#fff',
          zIndex: 1501,
          position: 'absolute',
          top: 50,
          left: 0,
          marginLeft: 8,
        }}
      >
        چند ضلعی
      </Button> }
       */}
      {checked && addressLive !== undefined && (
        <Box
          className='scroll-left'
          sx={{
            position: 'absolute',
            top: '94%',
            left: { xs: '71%', sm: '50%', md: '50%', lg: '50%' },
            transform: 'translate(-50%, -50%)',
            zIndex: 10000000000,
            p: 2,
            color: '#fff',
            background: 'gray',
            borderRadius: '10px',
            fontSize: '12px',
            width: { xs: '54%', sm: 1 / 4, md: 1 / 4, lg: 1 / 4 },
            boxShadow: '-0.5px 0 17px 7px #fd3333',
          }}
        >
          <Typography>{addressLive}</Typography>
        </Box>
      )}
    </Box>
  )
}

export default LocationScreen
